import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import CitationIcon from './icon/citations.svg';
import CitationCommand from './citationcommand';
export default class CitationUI extends Plugin {
  init() {
    const editor = this.editor;
    const t = editor.t;
    this.editor.commands.add( 'citation', new CitationCommand( this.editor ) );
    editor.ui.componentFactory.add( 'citation', locale => {
      const view = new ButtonView( locale );
      view.set( {
        label: t( 'Citations' ),
        tooltip: true,
        withText: false,
        icon: CitationIcon
      } );

      const command = editor.commands.get( 'citation' );
      view.bind( 'isEnabled' ).to( command );

      this.listenTo( view, 'execute', () => {
        editor.execute( 'citation' );
        editor.editing.view.focus();
      } );

      return view;
    } );
  }
}
